import PropTypes from 'prop-types';
import Box from 'components/UI/Box/Box';
import { ReactComponent as MedalRibbonsStarLogo } from 'assets/icons/medal-ribbons-star.svg';
import Button from 'components/UI/Button';
import LuchitoSrc from 'assets/images/luchito-promotion.png';
import { formatDate } from 'utils/formatDate';
import { ROUTE_PATH } from 'routes';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { formatCurrency, formatNumber } from 'utils/formatCurrency';

const Promotion = ({
  literals, points, promotion, onCreateCoupon,
}) => {
  const disabled = (points?.available || 0) < promotion.points && !promotion.couponId;
  return (
    <Box className='card-loyalty-promotion mb-4 relative' padding='sm'>
      <div className='flex items-center gap-2 mb-4'>
        <MedalRibbonsStarLogo width={48} />
        <p className='mb-0 font-bold text-lg'>{promotion.description}</p>
      </div>
      <p className='text-sm text-neutral-500 mt-2 mb-2'>{`#${promotion.id}`}</p>
      <div className='flex items-center gap-2 mb-2'>
        <p className='mb-0'>
          {promotion.couponId ? literals.pointsUsed : literals.pointsToUse}
        </p>
        <p className='mb-0 font-semibold'>
          {formatNumber(promotion.points, 0)}
        </p>
      </div>
      <div className='flex items-center gap-2 mb-2'>
        <p className='mb-0'>{literals.discount}</p>
        <p className='mb-0 font-semibold'>{`${promotion.discount}%`}</p>
      </div>
      {promotion.sections.length ? (
        <div className='flex items-center gap-2 mb-2'>
          <p className='mb-0'>{literals.applyIn}</p>
          <p className='mb-0 font-semibold'>
            {promotion.sections
              .map((section) => literals.sections[section] || section)
              .join(', ')}
          </p>
        </div>
      ) : null}
      <div className='flex items-center gap-2 mb-2'>
        <p className='mb-0'>{literals.life}</p>
        <p className='mb-0 font-semibold'>
          {formatDate(promotion.endDate, 'DD/MM/YYYY')}
        </p>
      </div>
      <div className='flex items-center gap-2 mb-6'>
        <p className='mb-0'>{literals.maxAmount}</p>
        <p className='mb-0 font-semibold'>{formatCurrency(promotion.maxAmount)}</p>
      </div>
      {promotion.couponId ? (
        <Button
          size='sm'
          className='w-1/2 flex items-center gap-2 justify-center'
          to={ROUTE_PATH.setLoyaltyPointsCoupon(promotion.couponId)}
        >
          <EyeIcon width={16} />
          {literals.goToCoupon}
        </Button>
      ) : (
        <Button
          text={literals.createCoupon}
          size='sm'
          className='w-1/2'
          onClick={() => onCreateCoupon(promotion)}
        />
      )}
      <img
        className='absolute bottom-0 img-promotion'
        src={LuchitoSrc}
        alt='Luchito'
        width={120}
      />
      {disabled && (
        <div className='promotion-disabled'>
          <p className='mb-0'>{literals.notEnoughPoints}</p>
        </div>
      )}
    </Box>
  );
};

Promotion.propTypes = {
  literals: PropTypes.object.isRequired,
  points: PropTypes.object.isRequired,
  promotion: PropTypes.object.isRequired,
  onCreateCoupon: PropTypes.func.isRequired,
};

export default Promotion;
